import { useEffect } from 'react'
import { Divider, Grid, Typography, useTheme, useMediaQuery } from '@mui/material'
import { ISettingsItem, useSettings } from '../../../Settings'
import { usePlan } from '../../../Plans'
import { useTranslation } from '../../../i18n'
import { ReactComponent as ActivatedPortability } from '../../../assets/icons/activatedPortability.svg'

export default function ActivatedBnfts({ name, variables }: ISettingsItem) {
  const { portability, chipOnly } = usePlan()
  const { isSurfMVNE } = useSettings()
  const { t } = useTranslation()
  const theme = useTheme()
  const isMd = useMediaQuery(theme.breakpoints.between('md', 'lg'))
  const defaultTextArray = [
    t.page1.activatedBnfts.title,
    t.page1.activatedBnfts.portabilityActivated,
    t.page1.activatedBnfts.moreInternet,
    t.page1.activatedBnfts.bonusGB,
  ]
  const { text } = variables || {}
  const mergedArray = text
    ? text.map((value, index) => (value !== undefined && value !== '' ? value : defaultTextArray[index]))
    : defaultTextArray

  useEffect(() => {
    const actvBnftsContainer = document.getElementById('content-right-activated-bnfts')
    const actvBnftsContainerFlw = document.getElementById('content-right-activated-bnfts-flw')

    // Para MVNEs Surf, ocultar completamente a seção de benefícios ativados (não há bônus +5GB)
    const display = /* isMd ? 'none' :  */(portability && !chipOnly && !isSurfMVNE ? 'flex' : 'none')

    if (actvBnftsContainer) actvBnftsContainer.style.display = display
    if (actvBnftsContainerFlw) actvBnftsContainerFlw.style.display = display
  },[portability, chipOnly, isMd, isSurfMVNE])

  // Para MVNEs Surf não há bônus +5GB, então não renderiza a seção de benefícios ativados
  if (isSurfMVNE) return null

  return (
    <Grid container item className={name ? `${name} activated-bnfts` : "activated-bnfts"} xs={12}>
      <Typography className="actvBnftsTitle" variant="h2" dangerouslySetInnerHTML={{ __html: mergedArray[0] }} />
      <Grid container item className="actvPortability" xs={12}>
        <Grid item  className="actvBnftsIcon">
          <ActivatedPortability />
        </Grid>
        <Grid item className="actvBnftsText">
          <Typography variant="h3" dangerouslySetInnerHTML={{ __html: mergedArray[1] }} />
          <Typography variant="body1" dangerouslySetInnerHTML={{ __html: mergedArray[2] }} />
        </Grid>
        <Grid item className="actvBnftsDetail">
          <Typography variant="body1" dangerouslySetInnerHTML={{ __html: mergedArray[3] }} />
        </Grid>
      </Grid>
      <Divider className="divider" />
    </Grid>
  )
}